<script lang="ts" setup>
  import { useTemplateRef } from 'vue';
  import { Button } from '../../../../shared/ui/button';
  import ModalSheet from '../ModalSheet.vue';

  defineEmits<{ close: [] }>();

  const sheet = useTemplateRef('sheet');
</script>

<template>
  <ModalSheet ref="sheet" title="Settings" @close="$emit('close')">
    <slot />
    <template #actions>
      <Button @click="sheet?.close()">Done</Button>
    </template>
  </ModalSheet>
</template>
